var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "page-heading" }, [_vm._v("API Calls")]),
    _vm._v(" "),
    _c("div", { attrs: { id: "content" } }, [
      _vm.section === "socialmedia"
        ? _c("div", [_c("socialmedia")], 1)
        : _vm.section === "personality"
        ? _c("div", [_c("personality")], 1)
        : _vm.section === "photo"
        ? _c("div", [_c("photo")], 1)
        : _vm.section === "news"
        ? _c("div", [_c("news")], 1)
        : _vm.section === "voice"
        ? _c("div", [_c("voice")], 1)
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "v-bottom-nav",
          {
            attrs: { active: _vm.section, value: true, fixed: "" },
            on: {
              "update:active": function($event) {
                _vm.section = $event
              }
            },
            model: {
              value: _vm.section,
              callback: function($$v) {
                _vm.section = $$v
              },
              expression: "section"
            }
          },
          [
            _c(
              "v-btn",
              { attrs: { color: "teal", flat: "", value: "socialmedia" } },
              [
                _c("span", [_vm._v("Social Media")]),
                _vm._v(" "),
                _c("v-icon", [_vm._v("group")])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              { attrs: { color: "teal", flat: "", value: "personality" } },
              [
                _c("span", [_vm._v("Personality")]),
                _vm._v(" "),
                _c("v-icon", [_vm._v("mood")])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              { attrs: { color: "teal", flat: "", value: "photo" } },
              [
                _c("span", [_vm._v("Photo")]),
                _vm._v(" "),
                _c("v-icon", [_vm._v("photo")])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              { attrs: { color: "teal", flat: "", value: "news" } },
              [
                _c("span", [_vm._v("News")]),
                _vm._v(" "),
                _c("v-icon", [_vm._v("location_city")])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              { attrs: { color: "teal", flat: "", value: "voice" } },
              [
                _c("span", [_vm._v("Voice")]),
                _vm._v(" "),
                _c("v-icon", [_vm._v("record_voice_over")])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e3985ba", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e3985ba","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserClass.vue
// module id = null
// module chunks = 